import React, { Component } from 'react';

class HabilitacionTarjeta extends Component {
    render() { 

        const {data,actions,tarjetaHabilitacion} = this.props;

        let tituloModal = "Habilitación de Tarjeta"
        let mensajeSuperior = "";

        if(tarjetaHabilitacion){
            mensajeSuperior = "¿Confirma la HABILITACIÓN de la tarjeta " + tarjetaHabilitacion.NumeroTarjeta + " del cliente " + tarjetaHabilitacion.NombreCliente + "?";
        }
        
        return (  
        <div className='modalIntegrantesInterior'>
            <div>
                {tituloModal}
            </div>
            <div className='modalHabilitacionTarjetaCuerpo'>
                <div>{mensajeSuperior}</div>
            </div>
            <div className='modaConfirmadorBloqueoInteriorFooter'>
                <button onClick={()=>actions.modalSeccion("IntegrantesCuenta","HABILITACION-TARJETA",false,null,"tarjetaHabilitacion")} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>null} className='btn btn-cta'>Confirmar</button>
            </div>
        </div>
       );
    }   
}
export default HabilitacionTarjeta;